import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { routes } from '@/domains/core/routing/routes/routes.default';
import { useAuth } from '@/domains/customerManagement/auth/hooks/useAuth';
import { signIn } from '@/domains/customerManagement/auth/services/client';
import { ABTests } from '@/domains/proB2BAnimation/abtests';

export const useUnloggedWishlistButton = (
  dispatchAddToWishlist: () => void,
  productId: number,
) => {
  const router = useRouter();
  const { isAuthenticated, isGuest } = useAuth();
  const [isUnifiedPlatformEnabled] = useBooleanFlags([ABTests.PEPE_UNIFY_AUTH]);

  const sessionStorageKey = `dispatchAddToWishlistAfterLogin[${productId}]`;

  useEffect(() => {
    if (isAuthenticated && !isGuest) {
      // if session storage has the key, perform add to wishlist
      if (sessionStorage.getItem(sessionStorageKey)) {
        sessionStorage.removeItem(sessionStorageKey);

        // under set timeout to not give priority to this task in main thread
        setTimeout(dispatchAddToWishlist, 200);
      }
    }
  }, [isAuthenticated, dispatchAddToWishlist, isGuest, sessionStorageKey]);

  const handleUnloggedClick = () => {
    sessionStorage.setItem(sessionStorageKey, 'true');

    if (isGuest) {
      router.push(
        `${routes.convertGuest}?redirect_url=${window.location.href}`,
      );
    } else {
      signIn({ unified: isUnifiedPlatformEnabled });
    }
  };

  return {
    isGuestOrAnon: isGuest || !isAuthenticated,
    handleUnloggedClick,
  };
};
